<template>
  <span>
    <v-btn class="btn-primary" dark @click="remind">
      <div class="text-btn">
        {{ $t('chat.remind-join-chat') }}
      </div>
    </v-btn>

    <v-dialog :value="modalOpened"
              transition="dialog-bottom-transition"
              content-class="payment-information"
              @click:outside="modalOpened = false">
      <template>
        <v-card>
          <v-card-title>
            {{ $t('Choose a contact') }}
          </v-card-title>
          <v-simple-table>
            <v-radio-group v-model="selectedUser">
              <tbody style="padding: 0 24px;">
                <tr v-for="item in chat.invited" :key="item._id" style="padding:0;">
                  <td> <v-radio :label="item.cif + '-' + item.name" :value="item._id" style="margin-left: 10px" @change="selectedUserInformation = item" /> </td>
                </tr>
              </tbody>
            </v-radio-group>
          </v-simple-table>

          <v-card-actions>
            <v-spacer />
          </v-card-actions>
          <inviteChatForm v-if="selectedUserInformation != null" :prop-mail="email" :prop-phone="phone" @invite="sendMessage" />
        </v-card>
      </template>
    </v-dialog>
  </span>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
import inviteChatForm from "../components/inviteChatForm";
import Constants from "../../constants";

export default {
    name: "RemindInvitationComponent",
    components: {inviteChatForm},
    props: {
        chat: {type: Object, default: null},
        invite: {type: Boolean, default: null},
        inviteByppay: {type: Boolean, default: null},

    },
    data () {
        return {
            email: "",
            phone: "",

            modalOpened: false,
            selectedUser: "",
            selectedUserInformation: null
        };
    },
    watch: {
        selectedUserInformation: function (val) {
            const contact = this.$user.contacts.find(e => e.cif.toLowerCase() === val.cif.toLowerCase());
            if (contact) {
                this.email = contact.email;
                this.phone = contact.phone;
            }
        }
    },
    created () {
        if (this.invite || this.inviteByppay)
            this.remind();
    },
    methods: {
        remind () {
            this.modalOpened = true;
            this.selectedUserInformation = null;
            this.$nextTick(() => {
                if (this.chat.invited.length > 0) {
                    this.selectedUserInformation = this.chat.invited[0];
                    this.selectedUser = this.chat.invited[0]._id;
                }
            });
        },
        sendMessage (event) {
            const inviteMethod = event.inviteMethod;
            const mail = event.mail;
            const phone = event.phone;
            const isPayer = (this.chat.factoring && this.selectedUserInformation.cif.toLowerCase() === this.chat.factoring.payer.cif.toLowerCase()) || (this.chat.invoice && !this.chat.factoring && this.selectedUserInformation.cif.toLowerCase() === this.chat.invoice.payerCif.toLowerCase());
            ApiRepository.remindMail(this.chat._id, this.selectedUserInformation._id, inviteMethod, mail, 'invite chat text', 'invite chat subject', 'inviteChat', isPayer).then((ret) => {
                const textMessage = this.extractContent(ret.data.messageHTML).replace(/\s{2,}/g, ' ').trim();
                if (inviteMethod === Constants.INVITE_METHOD.WHATSAP) {
                    this.inviteChatWhatsap(encodeURIComponent(textMessage), phone);
                } else if (inviteMethod === Constants.INVITE_METHOD.SMS) {
                    this.inviteChatSMS(textMessage, phone);
                }
                this.modalOpened = false;
                this.$root.$emit('show-snackbar', {message: this.$t('Contact reminded successfully!'), color: "success"});
            }).catch(() => { });
        },

        extractContent (s) {
            const span = document.createElement('span');
            span.innerHTML = s;
            return span.textContent || span.innerText;
        },
        getHrefAndroid (phone, message) {
            let messageToSend = message;
            const matches = message.match(/\bhttps?:\/\/\S+/);
            if (matches && matches[0]) {
                messageToSend = messageToSend.replace(matches[0].toString(), '');
                messageToSend = [messageToSend.slice(0, matches.index), encodeURIComponent(matches[0]), messageToSend.slice(matches.index)].join('');
            }
            return "sms:" + phone + "?body=" + encodeURIComponent(messageToSend);
        },
        getHrefiOS (phones, message) {
            let messageToSend = message;
            const matches = message.match(/\bhttps?:\/\/\S+/);
            if (matches && matches[0]) {
                messageToSend = messageToSend.replace(matches[0].toString(), '');
                messageToSend = [messageToSend.slice(0, matches.index), matches[0], messageToSend.slice(matches.index)].join('');
            }
            return "sms://open?addresses=" + phones + "/&body=" + encodeURIComponent(messageToSend);
        },
        isWin () {
            return (!this.isAndroid() && !this.isIOS());
        },
        isAndroid () {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            return /android/i.test(userAgent);
        },
        isIOS () {
            return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
              // iPad on iOS 13 detection
              || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
        },
        inviteChatWhatsap (message, phone) {
            // const message = Constants.BASE_URL + '/Chat?chatId=' + this.idChat + '&invoiceId=' + this.invoiceId + '&invite=1';
            window.location.replace("https://api.whatsapp.com/send?phone=34" + phone + "&abid=34677882757&text=" + message);
            // window.open("https://api.whatsapp.com/send?phone=+34" + phone + "&abid=+34677882757&text=" + message, '_blank');
        },
        inviteChatSMS (message, phone) {

            if (this.isAndroid())
                window.location = this.getHrefAndroid(phone, message);
            else if (this.isIOS())
                window.location.replace(this.getHrefiOS(phone, message));
        },
    }
};
</script>

<style scoped>
.divider{
    padding: 0 0 18px 0;
}
>>> .payment-information {
    align-self: flex-end;
}
>>> .v-text-field--outlined .v-label {
    top: 9px !important;
}
</style>
